module.exports = __webpack_public_path__ + "img/card.93378592.webp";